export default {
    Metadata: {
        Name: "PadRight",
        Description: "Pads the specified string to the right up to the length specified.  If no padding character is specified, a space is assumed.",
        Syntax: "PadRight(pad_string, toLength_number, padAs_string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(padString, length, padChar = ' ') { //Overload
        if (padChar === null || padChar === '') {
            padChar = ' ';
        }

        if (padString == null) {
            return null;
        }

        if (typeof padString !== 'string') {
            padString = padString.toString();
        }

        while (padString.length < length) {
            padString = padString + padChar;
        }

        return padString;
    },
};
